<template>
  <div class="contenido bg-primary">
    <div class="pt-16 py-6 mx-auto max-w-md block justify-center">
      <div class="text-center w-full">
        <h1 class="font-light text-white">CALENDARIO DE RUTINAS FIVO</h1>
      </div>
      <div class="mx-auto text-white text-center my-4">
        Conoce y organiza tus rutinas de ejercicio diarias y empieza a aprovechar
        nuestros entrenamientos, diseñados por los mejores expertos del fitness.
      </div>
      <div class="text-white text-center">Selecciona el dia de la semana para ver tu rutina.</div>

      <!-- Dias -->
      <div class="block justify-center">
        <div class="my-4" @click="selectDia(d)" v-for="(d,i) in diassemana" :key="i">
          <div class="cursor-pointer mx-auto bg-yellow dia text-center">
            <span class="text-center">{{ d.nombre }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    diassemana: {
      required: true
    }
  },
  methods: {
      selectDia(dia) {
          this.$emit('dia',dia);
      }
  }
};
</script>
<style lang="scss" scoped>
.contenido {
  min-height: calc(100vh - 70px);
  margin-top: 70px;
}

.dia {
  color: black;
  padding: 1.5rem 2rem;
  max-width: 200px;
  min-width: 150px;
  border-radius: 0.6rem;
  > span {
    font-size: 1.7rem;
    font-weight: 300;
  }
}
</style>
